export const semanticTokens = {
	colors: {
		greenAlpha: {
			default: "greenAlpha.500",
			_dark: "greenAlpha.500",
		},
		orangeAlpha: {
			default: "orangeAlpha.500",
			_dark: "orangeAlpha.500",
		},
		redAlpha: {
			default: "redAlpha.500",
			_dark: "redAlpha.500",
		},
		purpleAlpha: {
			default: "purpleAlpha.500",
			_dark: "purpleAlpha.500",
		},
		primary: {
			default: "purple.500",
			_dark: "purple.500",
		},
		text: {
			default: "black.500",
			_dark: "white.500",
		},
		textLight: {
			default: "black.200",
			_dark: "black.200",
		},
		error: {
			default: "red.500",
			_dark: "red.400",
		},
	},
};
